import React from 'react';
import { Space, VerticalSpace } from 'components/Space';
import { spacing } from 'constants/spacing';
import { Title } from 'components/Typography/Title';
import { Button } from 'components/Button';
import { EmptyIcon } from 'components/Icon/Custom';
import { Text } from 'components/Typography';
import { commonProps } from '../constants';
import { IStatusChildrenProps } from '../types';
import { useStatusPageHandlers } from '../useStatusPageHandlers';
import { Wrapper } from './styled';

const WorksInProgress: React.FC<IStatusChildrenProps> = ({ additionalDescription }) => {
  const { handleGoToMain } = useStatusPageHandlers();

  return (
    <Wrapper>
      <VerticalSpace size={20} {...commonProps}>
        <EmptyIcon />

        <VerticalSpace size={spacing.md} {...commonProps}>
          <VerticalSpace size={spacing.sm} {...commonProps}>
            <VerticalSpace size={spacing.xxs} {...commonProps}>
              <Title level='h6'>Идут технические работы</Title>

              <VerticalSpace size={0} {...commonProps}>
                <Text color='gray650' width={230} textAlign='center'>
                  Дождитесь окончания работ или обратитесь к администратору
                </Text>
              </VerticalSpace>

              {additionalDescription && (
                <Text color='gray650'>{additionalDescription}</Text>
              )}
            </VerticalSpace>
          </VerticalSpace>

          <Space>
            <Button variant='primary' onClick={handleGoToMain}>
              Перейти на главную
            </Button>
          </Space>
        </VerticalSpace>
      </VerticalSpace>
    </Wrapper>
  );
};

export default WorksInProgress;
